import React, { useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";

import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";

function ImageLightbox({ open, setOpen, images }) {
  const [index, setIndex] = useState(0);

  return (
    <Lightbox
      open={open}
      close={() => {
        setOpen(false);
        setIndex(0);
      }}
      slides={images.map((src) => ({ src }))}
      index={index}
      on={{ view: ({ index }) => setIndex(index) }}

      plugins={[Zoom, Thumbnails]}

      zoom={{
        maxZoomPixelRatio: 3,
      }}

      thumbnails={{
        position: "bottom",      // ✅ always bottom
        hideWhenZoomed: false,    // ✅ visible during zoom
        width: 100,
        height: 70,
        gap: 10,
        borderRadius: 8,
      }}
    />
  );
}

export default ImageLightbox;
